import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-highlights',
  templateUrl: './daily-highlights.component.html',
  styleUrls: ['./daily-highlights.component.css']
})
export class DailyHighlightsComponent {
expanditem=false;
}
